export default __webpack_public_path__ + "static/media/background_amphiteater.05c82e22.png";